module.exports = __webpack_public_path__ + "facelifting_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_2_before.jpg
// module id = 1052
// module chunks = 0